<template>
    <ModalConfirm
        id="modal-confirm-input-pengeluaran-kas-kecil"
        title="Konfirmasi Input Pengeluaran"
        :isSubmitting="isSubmitting"
        @submit="$emit('submit')"
    >
        <p>Apakah anda yakin untuk menyimpan pengeluaran kas kecil ini?</p>
        <b-form-group label="Total Pengeluaran" class="mb-0">
            <b-input-group prepend="Rp.">
                <b-form-input
                    :value="total"
                    name="kasKecilTotalPengeluaranConfirmInput"
                    :disabled="isSubmitting"
                    @input="$emit('update:total', $event)"
                />
            </b-input-group>
        </b-form-group>
    </ModalConfirm>
</template>

<script>
export default {
    name: "modal-kas-kecil-input-pengeluaran-confirm",
    props: {
        isSubmitting: { type: Boolean, default: false },
        total: { type: String, default: "" },
    },
}
</script>
